module.exports = __webpack_public_path__ + "img/page.55b4018a.png";